import VueMqDdExtension from './vue-mq-dd-extension'

declare module 'vue/types/vue' {
  export interface Vue {
    $screen: VueMqDdExtension
  }
}

export default {
  install(Vue: any) {
    Vue.prototype.$screen = new VueMqDdExtension()
  },
}
